import { formatHrefToPath } from "~/router/helpers";

const isSubPathOfBasePath = (subPath, basePath) => {
  // Escape special characters in the base path
  const escapedBasePath = basePath.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Create a regular expression to match the subpath
  const regex = new RegExp(`^${escapedBasePath}(/|$)`);

  // Test if the subpath matches the regular expression
  return regex.test(subPath);
};

const navigatingToActivePath = (toRoute, oldActiveLink) => {
  if (!oldActiveLink) return false;
  // Check if navigating to the same path (or sub-path)
  return isSubPathOfBasePath(
    formatHrefToPath(toRoute.path, false),
    formatHrefToPath(oldActiveLink.href, false),
  );
};

const isCustomerRoute = (toRoute) => isSubPathOfBasePath(
  formatHrefToPath(toRoute.path, false),
  formatHrefToPath("/customer", false),
);
const isDashboardRoute = (toRoute) => isSubPathOfBasePath(
  formatHrefToPath(toRoute.path, false),
  formatHrefToPath("/dashboard", false),
);
const disableOldActiveList = (link) => link.classList.remove("active");
const updateCustomerSidebar = (toRoute) => {
  const oldActiveList = document.querySelector(".sidebar-nav-links > li.active");
  const oldActiveLink = document.querySelector(".sidebar-nav-links > li.active > a");
  if (oldActiveList) {
    if (navigatingToActivePath(toRoute, oldActiveLink)) return;
    disableOldActiveList(oldActiveList);
  }

  const navLinks = [...document.querySelectorAll(".nav-links > li > a")];
  const newRoutePath = formatHrefToPath(toRoute.path, false);
  const newActiveLink = navLinks.find((navLink) => {
    const linkPath = formatHrefToPath(navLink.href, false);
    return isSubPathOfBasePath(newRoutePath, linkPath);
  });

  // Not all routes have a corrosponding sidebar link. So in that case we do nothing.
  if (!newActiveLink) return;

  const newActiveList = newActiveLink.closest("li");
  // If no corresponding element was found return.
  if (!newActiveList || newActiveList.classList.contains("active")) return;
  // Activate the new link
  newActiveList.classList.add("active");
};
const updateDashboardTabs = (toRoute) => {
  const oldActiveList = document.querySelector("#dashboard-tabs-wrapper > li.active");
  const oldActiveLink = document.querySelector("#dashboard-tabs-wrapper > li.active > a");

  if (oldActiveList) {
    if (navigatingToActivePath(toRoute, oldActiveLink)) return;
    disableOldActiveList(oldActiveList);
  }

  const navLinks = [...document.querySelectorAll("#dashboard-tabs-wrapper > li > a")];
  const newRoutePath = formatHrefToPath(toRoute.path, false);
  const newActiveLink = navLinks.find((navLink) => {
    const linkPath = formatHrefToPath(navLink.href, false);
    return isSubPathOfBasePath(newRoutePath, linkPath);
  });

  // Not all routes have a corrosponding sidebar link. So in that case we do nothing.
  if (!newActiveLink) return;

  const newActiveList = newActiveLink.closest("li");
  // If no corrosponding element was found return.
  if (!newActiveList || newActiveList.classList.contains("active")) return;
  // Activate the new link
  newActiveList.classList.add("active");
};
const updateActiveNavbarLinkOnNavigation = (toRoute) => {
  if (isCustomerRoute(toRoute)) {
    updateCustomerSidebar(toRoute);
  } else if (isDashboardRoute(toRoute)) {
    updateDashboardTabs(toRoute);
  }
};

// TODO: Add logic for updating badges in sidebar here too when it's going to be implemented.

export {
  // eslint-disable-next-line import/prefer-default-export
  updateDashboardTabs,
  updateActiveNavbarLinkOnNavigation,
};
